export const timezones = [
  { value: "America/Los_Angeles", label: "Pacific (PT)", abbr: "PT" },
  { value: "America/Denver", label: "Mountain (MT)", abbr: "MT" },
  { value: "America/Chicago", label: "Central (CT)", abbr: "CT" },
  { value: "America/New_York", label: "Eastern (ET)", abbr: "ET" },
];

/** Auto-generate display date from structured fields */
export const generateDateDisplay = (date: string, endDate: string) => {
  if (!date) return "";
  const fmt = (d: string) => {
    const dt = new Date(d + "T12:00:00");
    return dt.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" });
  };
  if (endDate && endDate !== date) {
    const start = new Date(date + "T12:00:00");
    const end = new Date(endDate + "T12:00:00");
    const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
    if (sameMonth) {
      return `${start.toLocaleDateString("en-US", { month: "long" })} ${start.getDate()}-${end.getDate()}, ${start.getFullYear()}`;
    }
    return `${fmt(date)} - ${fmt(endDate)}`;
  }
  return fmt(date);
};

/** Display for month-only events where the exact day is TBD, e.g. "August 2026" */
export const generateMonthYearDisplay = (date: string) => {
  if (!date) return "";
  const dt = new Date(date + "T12:00:00");
  return dt.toLocaleDateString("en-US", { month: "long", year: "numeric" });
};

/** Auto-generate display time from structured fields */
export const generateTimeDisplay = (startTime: string, endTime: string, tz: string) => {
  if (!startTime) return "Full Day Event";
  const fmt = (t: string) => {
    const [h, m] = t.split(":").map(Number);
    const ampm = h >= 12 ? "PM" : "AM";
    const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return `${h12}:${m.toString().padStart(2, "0")} ${ampm}`;
  };
  const tzAbbr = timezones.find((t) => t.value === tz)?.abbr || "";
  if (endTime) return `${fmt(startTime)} - ${fmt(endTime)} ${tzAbbr}`.trim();
  return `${fmt(startTime)} ${tzAbbr}`.trim();
};
